import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const PersonCheckSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default PersonCheckSVG;
